export default __webpack_public_path__ + "static/media/7_proximidade.512ce75e.svg";